import React from "react";
import LinksIndex from "../components/Links/LinksIndex/LinksIndex";


export default function Contact(): JSX.Element {
   return (
      <>
         <LinksIndex />
      </>
   )
}